import { ChangeEvent, ReactElement } from 'react';
import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';
import { OptimusTextKey, useLocalization } from '@optimus-web/localization';
import { Container } from '../../Container';
import { Divider } from '../../Divider';
import { DropdownItem } from '../../DropdownItem';
import { Selected } from '../../types';
import { useSelectAll } from '../hooks/useSelectAll';

interface SelectAllItemProps {
    items: ReactElement[];
    selected?: Selected;
    onChange?: (e: ChangeEvent, s: Selected) => void;
    onSelectAll?: (allSelected: boolean) => void;
    ariaSelected?: boolean;
    focused?: boolean;
    onMouseEnter?: () => void;
    shouldScrollIntoView?: boolean;
    name?: string;
    keyboardHandled?: boolean;
}

export const SelectAllItem = ({
    items,
    selected,
    onChange,
    onSelectAll,
    focused,
    onMouseEnter,
    shouldScrollIntoView,
    name,
    keyboardHandled,
}: SelectAllItemProps) => {
    const { t } = useLocalization();
    const { allSelected, indeterminate, handleSelectAll } = useSelectAll({
        items,
        selected,
        onChange,
        onSelectAll,
    });

    if (items.length === 0) return null;

    return (
        <Container padding={['0', '0', '50']}>
            <DropdownItem
                multiselect
                selected={allSelected}
                indeterminate={indeterminate}
                label={allSelected ? t(OptimusTextKey.DeselectAll) : t(OptimusTextKey.SelectAll)}
                onClick={handleSelectAll}
                role="option"
                data-test-select-all-item
                value={allSelected ? 'all' : ''}
                id={`${name}-select-all`}
                focused={focused}
                onMouseEnter={onMouseEnter}
                shouldScrollIntoView={shouldScrollIntoView}
                keyboardHandled={keyboardHandled}
            />
            <Container padding={['100', '0', '0']}>
                <DividerSyled />
            </Container>
        </Container>
    );
};

// Note: this style hack should be removed once the list layout for Select and DropdownButton is refactored
const DividerSyled = styled(Divider)`
    margin: 0 -${getSpacingToken('100')}px;
`;
